import type { TCustomer } from './CustomersTableColumns';

const PILL: Record<string, string> = {
  APPROVED: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  DENIED: 'border-red-200 bg-red-50 text-red-700',
  PENDING: 'border-amber-200 bg-amber-50 text-amber-700',
  'AWAITING REVIEW': 'border-amber-200 bg-amber-50 text-amber-700',
  'NEW LETTER NEEDED': 'border-red-200 bg-red-50 text-red-700',
  REJECTED: 'border-red-200 bg-red-50 text-red-700',
  SIGNED: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  SENT: 'border-amber-200 bg-amber-50 text-amber-700',
  DECLINED: 'border-red-200 bg-red-50 text-red-700',
  VOIDED: 'border-red-200 bg-red-50 text-red-700',
};

export const StatusPill = ({ value }: { value: string }) => (
  <span
    className={`inline-flex w-fit rounded-full border px-2 py-0.5 text-[10px] font-semibold ${PILL[value] ?? 'border-gray-200 bg-gray-50 text-gray-600'}`}
  >
    {value}
  </span>
);

/**
 * Accreditation status in the customers table. Status only: Approve/Deny and the DocuSign
 * links live on the customer page, opened from the row's arrow.
 */
const AccreditationReviewCell = ({ customer }: { customer: TCustomer }) => {
  const letterStatus = customer.accreditationLetterStatus;
  const reviewed = customer.accreditationReviewStatus;

  if (!letterStatus) {
    return <span className="text-xs text-muted-foreground">-</span>;
  }
  // Denied: the investor has to send a new letter to their verifier (status REJECTED until they do).
  if (letterStatus === 'REJECTED')
    return <StatusPill value="NEW LETTER NEEDED" />;
  if (reviewed) return <StatusPill value={reviewed} />;
  if (letterStatus === 'SIGNED') return <StatusPill value="AWAITING REVIEW" />;
  return (
    <div className="flex flex-col gap-1">
      <span className="text-[11px] text-muted-foreground">Letter</span>
      <StatusPill value={letterStatus} />
    </div>
  );
};

export default AccreditationReviewCell;
